import { extendTheme, type ThemeConfig } from '@chakra-ui/react';

const config: ThemeConfig = {
  initialColorMode: 'dark',
  useSystemColorMode: true,
};

const theme = extendTheme({
  config,
  colors: {
    brand: {
      100: '#44FFA8',
      200: '#44FFA8',
      300: '#44FFA8',
      400: '#44FFA8',
      500: '#44FFA8',
      600: '#44FFA8',
      700: '#44FFA8',
      800: '#44FFA8',
    },
  },
  fonts: {
    heading: 'Inter, sans-serif',
    body: 'Inter, sans-serif',
  },
  styles: {
    global: (props: any) => ({
      html: {
        backgroundColor: props.colorMode === 'dark' ? 'gray.900' : 'gray.50',
      },
      body: {
        bg: props.colorMode === 'dark' ? 'gray.900' : 'gray.50',
        color: props.colorMode === 'dark' ? 'white' : 'gray.800',
      },
    }),
  },
  components: {
    Button: {
      defaultProps: {
        colorScheme: 'blue',
      },
      variants: {
        solid: (props: any) => ({
          bg: props.colorMode === 'dark' ? 'blue.500' : 'blue.400',
          color: 'white',
          _hover: {
            bg: props.colorMode === 'dark' ? 'blue.600' : 'blue.500',
            transform: 'translateY(-2px)',
            boxShadow: 'lg',
          },
          _active: {
            bg: props.colorMode === 'dark' ? 'blue.700' : 'blue.600',
          },
          transition: 'all 0.2s',
        }),
      },
    },
    Heading: {
      baseStyle: {
        fontWeight: '700',
      },
    },
    Card: {
      baseStyle: (props: any) => ({
        container: {
          bg: props.colorMode === 'dark' ? 'gray.800' : 'white',
          borderRadius: 'xl',
          boxShadow: 'xl',
          transition: 'all 0.2s',
          _hover: {
            transform: 'translateY(-2px)',
            boxShadow: '2xl',
          },
        },
      }),
    },
  },
});

export default theme; 